import { Box } from '@factorialco/deprecated-design-system'
import { AtsTemplatesSettingsPageDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'

import { useAtsContext } from 'modules/ats/lib/atsContext'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

import { EvaluationForms } from './sections/EvaluationForms'
import { MessageTemplates } from './sections/MessageTemplates'
import { OfferLetterTemplates } from './sections/OfferLetterTemplates'
import { QuestionTemplates } from './sections/QuestionTemplates'

const TemplatesPage = () => {
  const { company } = useCurrentSession()
  const { data, loading } = useQuery(AtsTemplatesSettingsPageDocument, {
    variables: { companyId: company.id },
  })
  const { canManageAtsSettings } = useAtsContext()

  const featureAvailable = (id: string) => {
    return data?.companies.featureAvailabilitiesConnection.nodes.find((node) => node.id === id)
      ?.available
  }

  const showQuestionTemplates = featureAvailable('ats_customized_features')
  const showMessageTemplates = featureAvailable('ats_message_templates')
  const showEvaluationForms = canManageAtsSettings && featureAvailable('ats_evaluation_forms')
  // TO DO: remove the dev feature flag when the feature is ready
  const showOfferLetterTemplates =
    (data?.features.enabledFeatures.nodes.find((node) => node.name === 'ats_offer_letter')
      ?.enabled &&
      data?.features.enabledFeatures.nodes.find(
        (node) => node.name === 'dev_ats_offer_letter_templates'
      )?.enabled) ??
    false

  return (
    <ResponsivePage.Body
      error={null}
      loading={loading}
      showHeader={false}
      authorized={
        showQuestionTemplates ||
        showMessageTemplates ||
        showEvaluationForms ||
        showOfferLetterTemplates
      }
    >
      <Box gap="s48">
        {showQuestionTemplates && <QuestionTemplates companyId={company.id} />}
        {showMessageTemplates && <MessageTemplates />}
        {showEvaluationForms && <EvaluationForms />}
        {showOfferLetterTemplates && <OfferLetterTemplates />}
      </Box>
    </ResponsivePage.Body>
  )
}

export default TemplatesPage
